
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexRMd7SVtFthIA9GwvQj4Mlrw5HQjRhKVrIoG_457FqqrggMeta } from "/app/pages/lab/index.vue?macro=true";
import { default as _91id_935OkkVtNC_xYYaaRqqjb_MVKUiWANnSjmXLTXlCRP3GwMeta } from "/app/pages/blogs/[id].vue?macro=true";
import { default as touT79hF_28OYy_45HuL_45rwEIh2jucVgpEbISs0nLcl6KofwMeta } from "/app/pages/policy/tou.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta } from "/app/pages/admin/login.vue?macro=true";
import { default as indexaCz8SHUd2_ork3wKV1uxZ37d9BcpUadjIkvk7Swk9xAMeta } from "/app/pages/blogs/index.vue?macro=true";
import { default as indexIBoOEAx9d6Xj4iaHs41CHXTe_LLqtjobtJVrPwMvfowMeta } from "/app/pages/doctor/index.vue?macro=true";
import { default as indexqquBsVoqzZ9PtPOUjB5ScDMJIeZPv5XI7tvmkXNjguMMeta } from "/app/pages/contact/index.vue?macro=true";
import { default as indexDF_r_BwyEDxSQympDnA6NfMGMxKPowhWECja0Q_45FgYUMeta } from "/app/pages/lab/sti/index.vue?macro=true";
import { default as index32K_45yQGnJ8KB_iS40noL8224X0clZUBacMJicrH0qMEMeta } from "/app/pages/app/i693/index.vue?macro=true";
import { default as indexlTUR9UVizs8udTG79dGRdJwFezRbu9RmDr_45m_gLc_459EMeta } from "/app/pages/knowlege/index.vue?macro=true";
import { default as privacy5fqq31mlwqt6nAlF64zOSEORO77B1VfBMnG4D7r25wcMeta } from "/app/pages/policy/privacy.vue?macro=true";
import { default as indexdaPqNAEctzEzapc0DByaHg2itqRQVHCu7svMpegcXXUMeta } from "/app/pages/provider/index.vue?macro=true";
import { default as loginDtbOB4ryOX2LXFmsTkuAjWgCC8k9p5GDFS5v9dm5aSAMeta } from "/app/pages/provider/login.vue?macro=true";
import { default as successEsvAneLlSqPk1rXII7T7UGVmfsib9KbaMgc3NbXBZ4UMeta } from "/app/pages/payment/success.vue?macro=true";
import { default as indexwjiazSccvlxeWe7NKKx0pnOuiXxIrnzqmXwMOtuvZZIMeta } from "/app/pages/radiology/index.vue?macro=true";
import { default as indexwpHcS9P4HNY_EqMLZ7fCFgb9ZH9zIG476Mp_Gb6h9W0Meta } from "/app/pages/specialty/index.vue?macro=true";
import { default as indexKmGXX2PaJnnP9ATC6k7YGyZcz_459_ndBxNRRAhUU7DsEMeta } from "/app/pages/medication/index.vue?macro=true";
import { default as canceledvv1YRTlp48tZlrjhAip2eoPAB3FVe_45LfN7uPCymgWQkMeta } from "/app/pages/payment/canceled.vue?macro=true";
import { default as indexSLGqMIQiCXLHbZKRFifUfmSPrvAv3AMycdDRAdQorc8Meta } from "/app/pages/provider/3/index.vue?macro=true";
import { default as loginhNNisM8UabGSSpDtumEjKJE47rBtpK68vGx4T5M0_3cMeta } from "/app/pages/provider/4/login.vue?macro=true";
import { default as conciergelpf15LQh9AnCEyyMYDqus8yVkR1J9R5MpIdTblfc690Meta } from "/app/pages/contact/concierge.vue?macro=true";
import { default as registerkJiJZq9gWAXGfgDQ_45UJcV8R1el7DLFYDG3HymopxSSsMeta } from "/app/pages/provider/register.vue?macro=true";
import { default as dashboardzNBvVyPIM4NHyS1El8TG_ChnEroIkrUgXuLezr2nvJQMeta } from "/app/pages/provider/dashboard.vue?macro=true";
import { default as indexq6sqkNLagzD1VSGpmTy6GjL8f3LQu56rDdumeS6wHpgMeta } from "/app/pages/lab/locations/index.vue?macro=true";
import { default as seo_45evaluationqHjhQJz6vOtOdo_naPD61iZvMKT8XHX9ZVI2OKeYeCMMeta } from "/app/pages/admin/seo-evaluation.vue?macro=true";
import { default as clinic_45RvANEWsnJne1iG_pmwevLE1LSkpmGVYwiHCrf5_iG0Meta } from "/app/pages/provider/mgmt/clinic.vue?macro=true";
import { default as supplyYtTiCAaDTxK3051fIkWioKwNcVKwseVLzOcAGG3teQEMeta } from "/app/pages/provider/mgmt/supply.vue?macro=true";
import { default as blog_45managementWLwkf8NStOMcljg60NMzQwsxAD9KDGoSsLvlkaivfrEMeta } from "/app/pages/admin/blog-management.vue?macro=true";
import { default as data_45managementrIGAE6rhxXSvwWuMdO0qVvKIWZNpGjNo066gl_45GA8MwMeta } from "/app/pages/admin/data-management.vue?macro=true";
import { default as accountp3893Rdx31fRjojqdP5WPASZtmy3DE7znq_GFvXLAH4Meta } from "/app/pages/provider/mgmt/account.vue?macro=true";
import { default as indexiSXWLUppB2XBueHm_n27X_99bgOdygk8lH7bFJAaXXYMeta } from "/app/pages/specialty/[str]/index.vue?macro=true";
import { default as indexsGFTtYxeW8okXtbj2XyNaVSsycy1_17KV2gVB5aRYWMMeta } from "/app/pages/health-insurance/index.vue?macro=true";
import { default as indexlw6KCKWvvIRcGVuHowwaBTotTvAeqnNGwXyIhsaDjxwMeta } from "/app/pages/industry-partner/index.vue?macro=true";
import { default as clinic2jXENbvFhnXkvf_45hrGS9VLOaGvlzH4oBgaH9_J_bGRUMeta } from "/app/pages/provider/3/mgmt/clinic.vue?macro=true";
import { default as pharmacymwjzuMoB1Yi0M7_EdBoNLlUVMZ9mRHU0Zi4IJb5pExMMeta } from "/app/pages/provider/mgmt/pharmacy.vue?macro=true";
import { default as reviewed_45requestsRC4RLKrSWwwjt_456Ix_45imLebv0rf2M0sKh3QLpBaCgUIMeta } from "/app/pages/admin/reviewed-requests.vue?macro=true";
import { default as marketingUzAPVL8uKlkKQTzxR8DZPz6RvDM8rA6ChFpD0D_45VO8cMeta } from "/app/pages/provider/mgmt/marketing.vue?macro=true";
import { default as _91uuid_93EbdV1pUemZ4YcbkAUxP8GcTLChPm8FGW62lABe1idWEMeta } from "/app/pages/care-coordination/[uuid].vue?macro=true";
import { default as change_45passwordTQ_45x7qCaJ3d0uXtyGP8tbyDRevB9dtumuYbgyGGTDyYMeta } from "/app/pages/provider/change-password.vue?macro=true";
import { default as index9qE3xiayWsiynV_45sIDDwwXKctr8azbtLCMj13vo9ZIIMeta } from "/app/pages/provider/mgmt/appt/index.vue?macro=true";
import { default as complianceo7bY0s_458UGTkkDWFtXQmpCBQYJ2IMrxC0zHPvqsdD1wMeta } from "/app/pages/provider/mgmt/compliance.vue?macro=true";
import { default as membershipJ_NmIT9Qt5EsrevFWb5K03FR4q_D0zxVFcd2GLAR_YUMeta } from "/app/pages/provider/mgmt/membership.vue?macro=true";
import { default as new_45doctor_45requests1RL3ONPGIFTLjTv5CH9ivX8Tin0_45O0r0JfTO5BiIoi4Meta } from "/app/pages/admin/new-doctor-requests.vue?macro=true";
import { default as medical_45disclaimerT0jdpKdlp1dFKp30jydHJxNJ6LLdr1ZE0C7oOIfAnlgMeta } from "/app/pages/policy/medical-disclaimer.vue?macro=true";
import { default as indexnee6yoouA0eQ_45th3DsIHgxn2aeBMbGsg3Zz1KSj_458lMMeta } from "/app/pages/provider/3/mgmt/appt/index.vue?macro=true";
import { default as membershipbLb5NDJV_45m12Ylh3TEQLGnurKlymoIG5NMby7213vk0Meta } from "/app/pages/provider/3/mgmt/membership.vue?macro=true";
import { default as indexqCapO5ll1NQPRthSgP_SbBxMKEDo88VOE3IuqeoBkLgMeta } from "/app/pages/provider/4/dashboard/index.vue?macro=true";
import { default as forget_45password9_45whw7OpsuhekIsJvBYjDeJ03ooL4d_PUrvih8YQoYEMeta } from "/app/pages/provider/4/forget-password.vue?macro=true";
import { default as indexmOmRThJkcwesi_eGK24Vtl_45p_xDFK9HfO_45RS2aRLg8YMeta } from "/app/pages/provider/4/onboarding/index.vue?macro=true";
import { default as onboarding_45successCJLH6oB_45jXidBQth9iW4zEFIIYOLQxvZCq8qYFuYm58Meta } from "/app/pages/provider/onboarding-success.vue?macro=true";
import { default as calendarX6afqn_45EIKOySE0LqlOGs1o1vllMK2HpkhB6OcYF3JIMeta } from "/app/pages/provider/3/mgmt/appt/calendar.vue?macro=true";
import { default as indexwttrCs10Cud39AT7BdyStAJMBejL7Lq3x2zJJEPUmbkMeta } from "/app/pages/provider/3/mgmt/app/i693/index.vue?macro=true";
import { default as telephonyH0AaOQdf2lrmdYA462ISNCvnXyLmnLI9ghyvR401LB8Meta } from "/app/pages/provider/4/dashboard/telephony.vue?macro=true";
import { default as change_45passwordsR_4Yteo7kxJMmnUFTUH9OUt2lX9TlLAWozzWqGVvB0Meta } from "/app/pages/provider/3/mgmt/change-password.vue?macro=true";
import { default as indexs0uDmdC7RprN9gGW8_dD_d_4571NiQnUR9tMKfXm39IdIMeta } from "/app/pages/provider/4/dashboard/blog/index.vue?macro=true";
import { default as indexxWu0_457igiwKtsfTYH27jTwr_451ULMrhvOB08UaZ0f_K0Meta } from "/app/pages/provider/4/dashboard/team/index.vue?macro=true";
import { default as indexU9RhFYRKDyTVWscV2qgNgSPB7ENg2ro1j4CWs_45JkW0MMeta } from "/app/pages/provider/care-coordination/index.vue?macro=true";
import { default as indexhOvwoTFjpOlAk0qmruwVgvnQBmBSijlSM1aoClIwkU8Meta } from "/app/pages/doctor/[specialty]/[[slug]]/index.vue?macro=true";
import { default as accountlevel3RkmvtFauhsDMbHGXiWIcZTaFPmU5OeTBKHcY7xdlkQMeta } from "/app/pages/provider/4/dashboard/accountlevel.vue?macro=true";
import { default as createEkfNSuyjjmIx8gUYB4d0lFZL_kZaqre35CdglKtvQKYMeta } from "/app/pages/provider/care-coordination/create.vue?macro=true";
import { default as indexeZsFY5HMMWlb2d_45Qslz1yjGDreziFZS0Vpx862Jw2hgMeta } from "/app/pages/provider/4/dashboard/clinics/index.vue?macro=true";
import { default as scanneropH5P_bSb7kO3lNEiYZOZC7XkZCJGbNkjPmv58yjQF4Meta } from "/app/pages/provider/care-coordination/scanner.vue?macro=true";
import { default as index3638Y_45B95zkaIRFyIC7S6yhK19PEJa9jryVfCJActS0Meta } from "/app/pages/provider/4/dashboard/schedules/index.vue?macro=true";
import { default as indexkq7nWEjFUaDyMvftYOJv4nJajcYkCAEc3OCHCUcCkFAMeta } from "/app/pages/provider/4/dashboard/scheduling/index.vue?macro=true";
import { default as blog_45editingB_72DznYvxbzZD2gwdV1iGPrhXiw60ebaA9R_45IK5UZQMeta } from "/app/pages/provider/4/dashboard/blog/blog-editing.vue?macro=true";
import { default as _91uuid_93r448MYyBG1r37fXAbihea3ZDkvPqoFa6JpSBCw24_RcMeta } from "/app/pages/provider/care-coordination/edit/[uuid].vue?macro=true";
import { default as appointment4HAle_45D9MkkKj4DWy9frn9I_45_eH0DLkbAl3Sus4_45bpoMeta } from "/app/pages/doctor/[specialty]/[[slug]]/appointment.vue?macro=true";
import { default as indexxFAwUUtygNwLrLOBjkVN79ZIslCgVfdW9ReLALfwhLkMeta } from "/app/pages/provider/4/dashboard/appointments/index.vue?macro=true";
import { default as account_45upgrade_45doneJZ2OuLTE__F0Dj1E1fnGtUZq1Omjo8rNNuUOI_45vIVesMeta } from "/app/pages/provider/4/dashboard/account-upgrade-done.vue?macro=true";
import { default as _91uuid_93k7Ci4EEJYqNL5_knaVpMiinngEixoJlJewYJfmAjFEUMeta } from "/app/pages/provider/care-coordination/success/[uuid].vue?macro=true";
import { default as indexZdg_45dBZDn62ucR5ofpE44nCAFtGZV1On9UNKm8YXExIMeta } from "/app/pages/provider/3/mgmt/insurance-eligibility/index.vue?macro=true";
import { default as indexwp_jmw_45AMPRlXHV8b_45G4VF_u1P7O9JK6yf_60VUHuPkMeta } from "/app/pages/provider/3/mgmt/app/communications/voip/index.vue?macro=true";
import { default as update_45facility_45locationsnKARdlHTQ4Rtv44w2rZHJlbp1dK340EsS9f6pCxNI1oMeta } from "/app/pages/provider/4/dashboard/clinics/update-facility-locations.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en-US",
    path: "/en-US",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___zh-Hans",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___zh-Hant",
    path: "/zh-Hant",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "lab___en-US",
    path: "/en-US/lab",
    component: () => import("/app/pages/lab/index.vue")
  },
  {
    name: "lab___zh-Hans",
    path: "/lab",
    component: () => import("/app/pages/lab/index.vue")
  },
  {
    name: "lab___zh-Hant",
    path: "/zh-Hant/lab",
    component: () => import("/app/pages/lab/index.vue")
  },
  {
    name: "blogs-id___en-US",
    path: "/en-US/blogs/:id()",
    component: () => import("/app/pages/blogs/[id].vue")
  },
  {
    name: "blogs-id___zh-Hans",
    path: "/blogs/:id()",
    component: () => import("/app/pages/blogs/[id].vue")
  },
  {
    name: "blogs-id___zh-Hant",
    path: "/zh-Hant/blogs/:id()",
    component: () => import("/app/pages/blogs/[id].vue")
  },
  {
    name: "policy-tou___en-US",
    path: "/en-US/policy/tou",
    component: () => import("/app/pages/policy/tou.vue")
  },
  {
    name: "policy-tou___zh-Hans",
    path: "/policy/tou",
    component: () => import("/app/pages/policy/tou.vue")
  },
  {
    name: "policy-tou___zh-Hant",
    path: "/zh-Hant/policy/tou",
    component: () => import("/app/pages/policy/tou.vue")
  },
  {
    name: "admin___en-US",
    path: "/en-US/admin",
    meta: { ...(indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin___zh-Hans",
    path: "/admin",
    meta: { ...(indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin___zh-Hant",
    path: "/zh-Hant/admin",
    meta: { ...(indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-login___en-US",
    path: "/en-US/admin/login",
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "admin-login___zh-Hans",
    path: "/admin/login",
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "admin-login___zh-Hant",
    path: "/zh-Hant/admin/login",
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "blogs___en-US",
    path: "/en-US/blogs",
    component: () => import("/app/pages/blogs/index.vue")
  },
  {
    name: "blogs___zh-Hans",
    path: "/blogs",
    component: () => import("/app/pages/blogs/index.vue")
  },
  {
    name: "blogs___zh-Hant",
    path: "/zh-Hant/blogs",
    component: () => import("/app/pages/blogs/index.vue")
  },
  {
    name: "doctor___en-US",
    path: "/en-US/doctor",
    component: () => import("/app/pages/doctor/index.vue")
  },
  {
    name: "doctor___zh-Hans",
    path: "/doctor",
    component: () => import("/app/pages/doctor/index.vue")
  },
  {
    name: "doctor___zh-Hant",
    path: "/zh-Hant/doctor",
    component: () => import("/app/pages/doctor/index.vue")
  },
  {
    name: "contact___en-US",
    path: "/en-US/contact",
    component: () => import("/app/pages/contact/index.vue")
  },
  {
    name: "contact___zh-Hans",
    path: "/contact",
    component: () => import("/app/pages/contact/index.vue")
  },
  {
    name: "contact___zh-Hant",
    path: "/zh-Hant/contact",
    component: () => import("/app/pages/contact/index.vue")
  },
  {
    name: "lab-sti___en-US",
    path: "/en-US/lab/sti",
    component: () => import("/app/pages/lab/sti/index.vue")
  },
  {
    name: "lab-sti___zh-Hans",
    path: "/lab/sti",
    component: () => import("/app/pages/lab/sti/index.vue")
  },
  {
    name: "lab-sti___zh-Hant",
    path: "/zh-Hant/lab/sti",
    component: () => import("/app/pages/lab/sti/index.vue")
  },
  {
    name: "app-i693___en-US",
    path: "/en-US/app/i693",
    component: () => import("/app/pages/app/i693/index.vue")
  },
  {
    name: "app-i693___zh-Hans",
    path: "/app/i693",
    component: () => import("/app/pages/app/i693/index.vue")
  },
  {
    name: "app-i693___zh-Hant",
    path: "/zh-Hant/app/i693",
    component: () => import("/app/pages/app/i693/index.vue")
  },
  {
    name: "knowlege___en-US",
    path: "/en-US/knowlege",
    component: () => import("/app/pages/knowlege/index.vue")
  },
  {
    name: "knowlege___zh-Hans",
    path: "/knowlege",
    component: () => import("/app/pages/knowlege/index.vue")
  },
  {
    name: "knowlege___zh-Hant",
    path: "/zh-Hant/knowlege",
    component: () => import("/app/pages/knowlege/index.vue")
  },
  {
    name: "policy-privacy___en-US",
    path: "/en-US/policy/privacy",
    component: () => import("/app/pages/policy/privacy.vue")
  },
  {
    name: "policy-privacy___zh-Hans",
    path: "/policy/privacy",
    component: () => import("/app/pages/policy/privacy.vue")
  },
  {
    name: "policy-privacy___zh-Hant",
    path: "/zh-Hant/policy/privacy",
    component: () => import("/app/pages/policy/privacy.vue")
  },
  {
    name: "provider___en-US",
    path: "/en-US/provider",
    component: () => import("/app/pages/provider/index.vue")
  },
  {
    name: "provider___zh-Hans",
    path: "/provider",
    component: () => import("/app/pages/provider/index.vue")
  },
  {
    name: "provider___zh-Hant",
    path: "/zh-Hant/provider",
    component: () => import("/app/pages/provider/index.vue")
  },
  {
    name: "provider-login___en-US",
    path: "/en-US/provider/login",
    component: () => import("/app/pages/provider/login.vue")
  },
  {
    name: "provider-login___zh-Hans",
    path: "/provider/login",
    component: () => import("/app/pages/provider/login.vue")
  },
  {
    name: "provider-login___zh-Hant",
    path: "/zh-Hant/provider/login",
    component: () => import("/app/pages/provider/login.vue")
  },
  {
    name: "payment-success___en-US",
    path: "/en-US/payment/success",
    component: () => import("/app/pages/payment/success.vue")
  },
  {
    name: "payment-success___zh-Hans",
    path: "/payment/success",
    component: () => import("/app/pages/payment/success.vue")
  },
  {
    name: "payment-success___zh-Hant",
    path: "/zh-Hant/payment/success",
    component: () => import("/app/pages/payment/success.vue")
  },
  {
    name: "radiology___en-US",
    path: "/en-US/radiology",
    component: () => import("/app/pages/radiology/index.vue")
  },
  {
    name: "radiology___zh-Hans",
    path: "/radiology",
    component: () => import("/app/pages/radiology/index.vue")
  },
  {
    name: "radiology___zh-Hant",
    path: "/zh-Hant/radiology",
    component: () => import("/app/pages/radiology/index.vue")
  },
  {
    name: "specialty___en-US",
    path: "/en-US/specialty",
    component: () => import("/app/pages/specialty/index.vue")
  },
  {
    name: "specialty___zh-Hans",
    path: "/specialty",
    component: () => import("/app/pages/specialty/index.vue")
  },
  {
    name: "specialty___zh-Hant",
    path: "/zh-Hant/specialty",
    component: () => import("/app/pages/specialty/index.vue")
  },
  {
    name: "medication___en-US",
    path: "/en-US/medication",
    component: () => import("/app/pages/medication/index.vue")
  },
  {
    name: "medication___zh-Hans",
    path: "/medication",
    component: () => import("/app/pages/medication/index.vue")
  },
  {
    name: "medication___zh-Hant",
    path: "/zh-Hant/medication",
    component: () => import("/app/pages/medication/index.vue")
  },
  {
    name: "payment-canceled___en-US",
    path: "/en-US/payment/canceled",
    component: () => import("/app/pages/payment/canceled.vue")
  },
  {
    name: "payment-canceled___zh-Hans",
    path: "/payment/canceled",
    component: () => import("/app/pages/payment/canceled.vue")
  },
  {
    name: "payment-canceled___zh-Hant",
    path: "/zh-Hant/payment/canceled",
    component: () => import("/app/pages/payment/canceled.vue")
  },
  {
    name: "provider-3___en-US",
    path: "/en-US/provider/3",
    meta: indexSLGqMIQiCXLHbZKRFifUfmSPrvAv3AMycdDRAdQorc8Meta || {},
    component: () => import("/app/pages/provider/3/index.vue")
  },
  {
    name: "provider-3___zh-Hans",
    path: "/provider/3",
    meta: indexSLGqMIQiCXLHbZKRFifUfmSPrvAv3AMycdDRAdQorc8Meta || {},
    component: () => import("/app/pages/provider/3/index.vue")
  },
  {
    name: "provider-3___zh-Hant",
    path: "/zh-Hant/provider/3",
    meta: indexSLGqMIQiCXLHbZKRFifUfmSPrvAv3AMycdDRAdQorc8Meta || {},
    component: () => import("/app/pages/provider/3/index.vue")
  },
  {
    name: "provider-4-login___en-US",
    path: "/en-US/provider/4/login",
    meta: loginhNNisM8UabGSSpDtumEjKJE47rBtpK68vGx4T5M0_3cMeta || {},
    component: () => import("/app/pages/provider/4/login.vue")
  },
  {
    name: "provider-4-login___zh-Hans",
    path: "/provider/4/login",
    meta: loginhNNisM8UabGSSpDtumEjKJE47rBtpK68vGx4T5M0_3cMeta || {},
    component: () => import("/app/pages/provider/4/login.vue")
  },
  {
    name: "provider-4-login___zh-Hant",
    path: "/zh-Hant/provider/4/login",
    meta: loginhNNisM8UabGSSpDtumEjKJE47rBtpK68vGx4T5M0_3cMeta || {},
    component: () => import("/app/pages/provider/4/login.vue")
  },
  {
    name: "contact-concierge___en-US",
    path: "/en-US/contact/concierge",
    component: () => import("/app/pages/contact/concierge.vue")
  },
  {
    name: "contact-concierge___zh-Hans",
    path: "/contact/concierge",
    component: () => import("/app/pages/contact/concierge.vue")
  },
  {
    name: "contact-concierge___zh-Hant",
    path: "/zh-Hant/contact/concierge",
    component: () => import("/app/pages/contact/concierge.vue")
  },
  {
    name: "provider-register___en-US",
    path: "/en-US/provider/register",
    meta: registerkJiJZq9gWAXGfgDQ_45UJcV8R1el7DLFYDG3HymopxSSsMeta || {},
    component: () => import("/app/pages/provider/register.vue")
  },
  {
    name: "provider-register___zh-Hans",
    path: "/provider/register",
    meta: registerkJiJZq9gWAXGfgDQ_45UJcV8R1el7DLFYDG3HymopxSSsMeta || {},
    component: () => import("/app/pages/provider/register.vue")
  },
  {
    name: "provider-register___zh-Hant",
    path: "/zh-Hant/provider/register",
    meta: registerkJiJZq9gWAXGfgDQ_45UJcV8R1el7DLFYDG3HymopxSSsMeta || {},
    component: () => import("/app/pages/provider/register.vue")
  },
  {
    name: "provider-dashboard___en-US",
    path: "/en-US/provider/dashboard",
    meta: dashboardzNBvVyPIM4NHyS1El8TG_ChnEroIkrUgXuLezr2nvJQMeta || {},
    component: () => import("/app/pages/provider/dashboard.vue")
  },
  {
    name: "provider-dashboard___zh-Hans",
    path: "/provider/dashboard",
    meta: dashboardzNBvVyPIM4NHyS1El8TG_ChnEroIkrUgXuLezr2nvJQMeta || {},
    component: () => import("/app/pages/provider/dashboard.vue")
  },
  {
    name: "provider-dashboard___zh-Hant",
    path: "/zh-Hant/provider/dashboard",
    meta: dashboardzNBvVyPIM4NHyS1El8TG_ChnEroIkrUgXuLezr2nvJQMeta || {},
    component: () => import("/app/pages/provider/dashboard.vue")
  },
  {
    name: "lab-locations___en-US",
    path: "/en-US/lab/locations",
    component: () => import("/app/pages/lab/locations/index.vue")
  },
  {
    name: "lab-locations___zh-Hans",
    path: "/lab/locations",
    component: () => import("/app/pages/lab/locations/index.vue")
  },
  {
    name: "lab-locations___zh-Hant",
    path: "/zh-Hant/lab/locations",
    component: () => import("/app/pages/lab/locations/index.vue")
  },
  {
    name: "admin-seo-evaluation___en-US",
    path: "/en-US/admin/seo-evaluation",
    meta: { ...(seo_45evaluationqHjhQJz6vOtOdo_naPD61iZvMKT8XHX9ZVI2OKeYeCMMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/seo-evaluation.vue")
  },
  {
    name: "admin-seo-evaluation___zh-Hans",
    path: "/admin/seo-evaluation",
    meta: { ...(seo_45evaluationqHjhQJz6vOtOdo_naPD61iZvMKT8XHX9ZVI2OKeYeCMMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/seo-evaluation.vue")
  },
  {
    name: "admin-seo-evaluation___zh-Hant",
    path: "/zh-Hant/admin/seo-evaluation",
    meta: { ...(seo_45evaluationqHjhQJz6vOtOdo_naPD61iZvMKT8XHX9ZVI2OKeYeCMMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/seo-evaluation.vue")
  },
  {
    name: "provider-mgmt-clinic___en-US",
    path: "/en-US/provider/mgmt/clinic",
    meta: clinic_45RvANEWsnJne1iG_pmwevLE1LSkpmGVYwiHCrf5_iG0Meta || {},
    component: () => import("/app/pages/provider/mgmt/clinic.vue")
  },
  {
    name: "provider-mgmt-clinic___zh-Hans",
    path: "/provider/mgmt/clinic",
    meta: clinic_45RvANEWsnJne1iG_pmwevLE1LSkpmGVYwiHCrf5_iG0Meta || {},
    component: () => import("/app/pages/provider/mgmt/clinic.vue")
  },
  {
    name: "provider-mgmt-clinic___zh-Hant",
    path: "/zh-Hant/provider/mgmt/clinic",
    meta: clinic_45RvANEWsnJne1iG_pmwevLE1LSkpmGVYwiHCrf5_iG0Meta || {},
    component: () => import("/app/pages/provider/mgmt/clinic.vue")
  },
  {
    name: "provider-mgmt-supply___en-US",
    path: "/en-US/provider/mgmt/supply",
    meta: supplyYtTiCAaDTxK3051fIkWioKwNcVKwseVLzOcAGG3teQEMeta || {},
    component: () => import("/app/pages/provider/mgmt/supply.vue")
  },
  {
    name: "provider-mgmt-supply___zh-Hans",
    path: "/provider/mgmt/supply",
    meta: supplyYtTiCAaDTxK3051fIkWioKwNcVKwseVLzOcAGG3teQEMeta || {},
    component: () => import("/app/pages/provider/mgmt/supply.vue")
  },
  {
    name: "provider-mgmt-supply___zh-Hant",
    path: "/zh-Hant/provider/mgmt/supply",
    meta: supplyYtTiCAaDTxK3051fIkWioKwNcVKwseVLzOcAGG3teQEMeta || {},
    component: () => import("/app/pages/provider/mgmt/supply.vue")
  },
  {
    name: "admin-blog-management___en-US",
    path: "/en-US/admin/blog-management",
    meta: { ...(blog_45managementWLwkf8NStOMcljg60NMzQwsxAD9KDGoSsLvlkaivfrEMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/blog-management.vue")
  },
  {
    name: "admin-blog-management___zh-Hans",
    path: "/admin/blog-management",
    meta: { ...(blog_45managementWLwkf8NStOMcljg60NMzQwsxAD9KDGoSsLvlkaivfrEMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/blog-management.vue")
  },
  {
    name: "admin-blog-management___zh-Hant",
    path: "/zh-Hant/admin/blog-management",
    meta: { ...(blog_45managementWLwkf8NStOMcljg60NMzQwsxAD9KDGoSsLvlkaivfrEMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/blog-management.vue")
  },
  {
    name: "admin-data-management___en-US",
    path: "/en-US/admin/data-management",
    meta: { ...(data_45managementrIGAE6rhxXSvwWuMdO0qVvKIWZNpGjNo066gl_45GA8MwMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/data-management.vue")
  },
  {
    name: "admin-data-management___zh-Hans",
    path: "/admin/data-management",
    meta: { ...(data_45managementrIGAE6rhxXSvwWuMdO0qVvKIWZNpGjNo066gl_45GA8MwMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/data-management.vue")
  },
  {
    name: "admin-data-management___zh-Hant",
    path: "/zh-Hant/admin/data-management",
    meta: { ...(data_45managementrIGAE6rhxXSvwWuMdO0qVvKIWZNpGjNo066gl_45GA8MwMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/data-management.vue")
  },
  {
    name: "provider-mgmt-account___en-US",
    path: "/en-US/provider/mgmt/account",
    meta: accountp3893Rdx31fRjojqdP5WPASZtmy3DE7znq_GFvXLAH4Meta || {},
    component: () => import("/app/pages/provider/mgmt/account.vue")
  },
  {
    name: "provider-mgmt-account___zh-Hans",
    path: "/provider/mgmt/account",
    meta: accountp3893Rdx31fRjojqdP5WPASZtmy3DE7znq_GFvXLAH4Meta || {},
    component: () => import("/app/pages/provider/mgmt/account.vue")
  },
  {
    name: "provider-mgmt-account___zh-Hant",
    path: "/zh-Hant/provider/mgmt/account",
    meta: accountp3893Rdx31fRjojqdP5WPASZtmy3DE7znq_GFvXLAH4Meta || {},
    component: () => import("/app/pages/provider/mgmt/account.vue")
  },
  {
    name: "specialty-str___en-US",
    path: "/en-US/specialty/:str()",
    component: () => import("/app/pages/specialty/[str]/index.vue")
  },
  {
    name: "specialty-str___zh-Hans",
    path: "/specialty/:str()",
    component: () => import("/app/pages/specialty/[str]/index.vue")
  },
  {
    name: "specialty-str___zh-Hant",
    path: "/zh-Hant/specialty/:str()",
    component: () => import("/app/pages/specialty/[str]/index.vue")
  },
  {
    name: "health-insurance___en-US",
    path: "/en-US/health-insurance",
    component: () => import("/app/pages/health-insurance/index.vue")
  },
  {
    name: "health-insurance___zh-Hans",
    path: "/health-insurance",
    component: () => import("/app/pages/health-insurance/index.vue")
  },
  {
    name: "health-insurance___zh-Hant",
    path: "/zh-Hant/health-insurance",
    component: () => import("/app/pages/health-insurance/index.vue")
  },
  {
    name: "industry-partner___en-US",
    path: "/en-US/industry-partner",
    component: () => import("/app/pages/industry-partner/index.vue")
  },
  {
    name: "industry-partner___zh-Hans",
    path: "/industry-partner",
    component: () => import("/app/pages/industry-partner/index.vue")
  },
  {
    name: "industry-partner___zh-Hant",
    path: "/zh-Hant/industry-partner",
    component: () => import("/app/pages/industry-partner/index.vue")
  },
  {
    name: "provider-3-mgmt-clinic___en-US",
    path: "/en-US/provider/3/mgmt/clinic",
    meta: clinic2jXENbvFhnXkvf_45hrGS9VLOaGvlzH4oBgaH9_J_bGRUMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/clinic.vue")
  },
  {
    name: "provider-3-mgmt-clinic___zh-Hans",
    path: "/provider/3/mgmt/clinic",
    meta: clinic2jXENbvFhnXkvf_45hrGS9VLOaGvlzH4oBgaH9_J_bGRUMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/clinic.vue")
  },
  {
    name: "provider-3-mgmt-clinic___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/clinic",
    meta: clinic2jXENbvFhnXkvf_45hrGS9VLOaGvlzH4oBgaH9_J_bGRUMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/clinic.vue")
  },
  {
    name: "provider-mgmt-pharmacy___en-US",
    path: "/en-US/provider/mgmt/pharmacy",
    meta: pharmacymwjzuMoB1Yi0M7_EdBoNLlUVMZ9mRHU0Zi4IJb5pExMMeta || {},
    component: () => import("/app/pages/provider/mgmt/pharmacy.vue")
  },
  {
    name: "provider-mgmt-pharmacy___zh-Hans",
    path: "/provider/mgmt/pharmacy",
    meta: pharmacymwjzuMoB1Yi0M7_EdBoNLlUVMZ9mRHU0Zi4IJb5pExMMeta || {},
    component: () => import("/app/pages/provider/mgmt/pharmacy.vue")
  },
  {
    name: "provider-mgmt-pharmacy___zh-Hant",
    path: "/zh-Hant/provider/mgmt/pharmacy",
    meta: pharmacymwjzuMoB1Yi0M7_EdBoNLlUVMZ9mRHU0Zi4IJb5pExMMeta || {},
    component: () => import("/app/pages/provider/mgmt/pharmacy.vue")
  },
  {
    name: "admin-reviewed-requests___en-US",
    path: "/en-US/admin/reviewed-requests",
    meta: { ...(reviewed_45requestsRC4RLKrSWwwjt_456Ix_45imLebv0rf2M0sKh3QLpBaCgUIMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/reviewed-requests.vue")
  },
  {
    name: "admin-reviewed-requests___zh-Hans",
    path: "/admin/reviewed-requests",
    meta: { ...(reviewed_45requestsRC4RLKrSWwwjt_456Ix_45imLebv0rf2M0sKh3QLpBaCgUIMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/reviewed-requests.vue")
  },
  {
    name: "admin-reviewed-requests___zh-Hant",
    path: "/zh-Hant/admin/reviewed-requests",
    meta: { ...(reviewed_45requestsRC4RLKrSWwwjt_456Ix_45imLebv0rf2M0sKh3QLpBaCgUIMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/reviewed-requests.vue")
  },
  {
    name: "provider-mgmt-marketing___en-US",
    path: "/en-US/provider/mgmt/marketing",
    meta: marketingUzAPVL8uKlkKQTzxR8DZPz6RvDM8rA6ChFpD0D_45VO8cMeta || {},
    component: () => import("/app/pages/provider/mgmt/marketing.vue")
  },
  {
    name: "provider-mgmt-marketing___zh-Hans",
    path: "/provider/mgmt/marketing",
    meta: marketingUzAPVL8uKlkKQTzxR8DZPz6RvDM8rA6ChFpD0D_45VO8cMeta || {},
    component: () => import("/app/pages/provider/mgmt/marketing.vue")
  },
  {
    name: "provider-mgmt-marketing___zh-Hant",
    path: "/zh-Hant/provider/mgmt/marketing",
    meta: marketingUzAPVL8uKlkKQTzxR8DZPz6RvDM8rA6ChFpD0D_45VO8cMeta || {},
    component: () => import("/app/pages/provider/mgmt/marketing.vue")
  },
  {
    name: "care-coordination-uuid___en-US",
    path: "/en-US/care-coordination/:uuid()",
    component: () => import("/app/pages/care-coordination/[uuid].vue")
  },
  {
    name: "care-coordination-uuid___zh-Hans",
    path: "/care-coordination/:uuid()",
    component: () => import("/app/pages/care-coordination/[uuid].vue")
  },
  {
    name: "care-coordination-uuid___zh-Hant",
    path: "/zh-Hant/care-coordination/:uuid()",
    component: () => import("/app/pages/care-coordination/[uuid].vue")
  },
  {
    name: "provider-change-password___en-US",
    path: "/en-US/provider/change-password",
    component: () => import("/app/pages/provider/change-password.vue")
  },
  {
    name: "provider-change-password___zh-Hans",
    path: "/provider/change-password",
    component: () => import("/app/pages/provider/change-password.vue")
  },
  {
    name: "provider-change-password___zh-Hant",
    path: "/zh-Hant/provider/change-password",
    component: () => import("/app/pages/provider/change-password.vue")
  },
  {
    name: "provider-mgmt-appt___en-US",
    path: "/en-US/provider/mgmt/appt",
    meta: index9qE3xiayWsiynV_45sIDDwwXKctr8azbtLCMj13vo9ZIIMeta || {},
    component: () => import("/app/pages/provider/mgmt/appt/index.vue")
  },
  {
    name: "provider-mgmt-appt___zh-Hans",
    path: "/provider/mgmt/appt",
    meta: index9qE3xiayWsiynV_45sIDDwwXKctr8azbtLCMj13vo9ZIIMeta || {},
    component: () => import("/app/pages/provider/mgmt/appt/index.vue")
  },
  {
    name: "provider-mgmt-appt___zh-Hant",
    path: "/zh-Hant/provider/mgmt/appt",
    meta: index9qE3xiayWsiynV_45sIDDwwXKctr8azbtLCMj13vo9ZIIMeta || {},
    component: () => import("/app/pages/provider/mgmt/appt/index.vue")
  },
  {
    name: "provider-mgmt-compliance___en-US",
    path: "/en-US/provider/mgmt/compliance",
    meta: complianceo7bY0s_458UGTkkDWFtXQmpCBQYJ2IMrxC0zHPvqsdD1wMeta || {},
    component: () => import("/app/pages/provider/mgmt/compliance.vue")
  },
  {
    name: "provider-mgmt-compliance___zh-Hans",
    path: "/provider/mgmt/compliance",
    meta: complianceo7bY0s_458UGTkkDWFtXQmpCBQYJ2IMrxC0zHPvqsdD1wMeta || {},
    component: () => import("/app/pages/provider/mgmt/compliance.vue")
  },
  {
    name: "provider-mgmt-compliance___zh-Hant",
    path: "/zh-Hant/provider/mgmt/compliance",
    meta: complianceo7bY0s_458UGTkkDWFtXQmpCBQYJ2IMrxC0zHPvqsdD1wMeta || {},
    component: () => import("/app/pages/provider/mgmt/compliance.vue")
  },
  {
    name: "provider-mgmt-membership___en-US",
    path: "/en-US/provider/mgmt/membership",
    meta: membershipJ_NmIT9Qt5EsrevFWb5K03FR4q_D0zxVFcd2GLAR_YUMeta || {},
    component: () => import("/app/pages/provider/mgmt/membership.vue")
  },
  {
    name: "provider-mgmt-membership___zh-Hans",
    path: "/provider/mgmt/membership",
    meta: membershipJ_NmIT9Qt5EsrevFWb5K03FR4q_D0zxVFcd2GLAR_YUMeta || {},
    component: () => import("/app/pages/provider/mgmt/membership.vue")
  },
  {
    name: "provider-mgmt-membership___zh-Hant",
    path: "/zh-Hant/provider/mgmt/membership",
    meta: membershipJ_NmIT9Qt5EsrevFWb5K03FR4q_D0zxVFcd2GLAR_YUMeta || {},
    component: () => import("/app/pages/provider/mgmt/membership.vue")
  },
  {
    name: "admin-new-doctor-requests___en-US",
    path: "/en-US/admin/new-doctor-requests",
    meta: { ...(new_45doctor_45requests1RL3ONPGIFTLjTv5CH9ivX8Tin0_45O0r0JfTO5BiIoi4Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/new-doctor-requests.vue")
  },
  {
    name: "admin-new-doctor-requests___zh-Hans",
    path: "/admin/new-doctor-requests",
    meta: { ...(new_45doctor_45requests1RL3ONPGIFTLjTv5CH9ivX8Tin0_45O0r0JfTO5BiIoi4Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/new-doctor-requests.vue")
  },
  {
    name: "admin-new-doctor-requests___zh-Hant",
    path: "/zh-Hant/admin/new-doctor-requests",
    meta: { ...(new_45doctor_45requests1RL3ONPGIFTLjTv5CH9ivX8Tin0_45O0r0JfTO5BiIoi4Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/pages/admin/new-doctor-requests.vue")
  },
  {
    name: "policy-medical-disclaimer___en-US",
    path: "/en-US/policy/medical-disclaimer",
    component: () => import("/app/pages/policy/medical-disclaimer.vue")
  },
  {
    name: "policy-medical-disclaimer___zh-Hans",
    path: "/policy/medical-disclaimer",
    component: () => import("/app/pages/policy/medical-disclaimer.vue")
  },
  {
    name: "policy-medical-disclaimer___zh-Hant",
    path: "/zh-Hant/policy/medical-disclaimer",
    component: () => import("/app/pages/policy/medical-disclaimer.vue")
  },
  {
    name: "provider-3-mgmt-appt___en-US",
    path: "/en-US/provider/3/mgmt/appt",
    meta: indexnee6yoouA0eQ_45th3DsIHgxn2aeBMbGsg3Zz1KSj_458lMMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/appt/index.vue")
  },
  {
    name: "provider-3-mgmt-appt___zh-Hans",
    path: "/provider/3/mgmt/appt",
    meta: indexnee6yoouA0eQ_45th3DsIHgxn2aeBMbGsg3Zz1KSj_458lMMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/appt/index.vue")
  },
  {
    name: "provider-3-mgmt-appt___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/appt",
    meta: indexnee6yoouA0eQ_45th3DsIHgxn2aeBMbGsg3Zz1KSj_458lMMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/appt/index.vue")
  },
  {
    name: "provider-3-mgmt-membership___en-US",
    path: "/en-US/provider/3/mgmt/membership",
    meta: membershipbLb5NDJV_45m12Ylh3TEQLGnurKlymoIG5NMby7213vk0Meta || {},
    component: () => import("/app/pages/provider/3/mgmt/membership.vue")
  },
  {
    name: "provider-3-mgmt-membership___zh-Hans",
    path: "/provider/3/mgmt/membership",
    meta: membershipbLb5NDJV_45m12Ylh3TEQLGnurKlymoIG5NMby7213vk0Meta || {},
    component: () => import("/app/pages/provider/3/mgmt/membership.vue")
  },
  {
    name: "provider-3-mgmt-membership___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/membership",
    meta: membershipbLb5NDJV_45m12Ylh3TEQLGnurKlymoIG5NMby7213vk0Meta || {},
    component: () => import("/app/pages/provider/3/mgmt/membership.vue")
  },
  {
    name: "provider-4-dashboard___en-US",
    path: "/en-US/provider/4/dashboard",
    meta: { ...(indexqCapO5ll1NQPRthSgP_SbBxMKEDo88VOE3IuqeoBkLgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/index.vue")
  },
  {
    name: "provider-4-dashboard___zh-Hans",
    path: "/provider/4/dashboard",
    meta: { ...(indexqCapO5ll1NQPRthSgP_SbBxMKEDo88VOE3IuqeoBkLgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/index.vue")
  },
  {
    name: "provider-4-dashboard___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard",
    meta: { ...(indexqCapO5ll1NQPRthSgP_SbBxMKEDo88VOE3IuqeoBkLgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/index.vue")
  },
  {
    name: "provider-4-forget-password___en-US",
    path: "/en-US/provider/4/forget-password",
    meta: forget_45password9_45whw7OpsuhekIsJvBYjDeJ03ooL4d_PUrvih8YQoYEMeta || {},
    component: () => import("/app/pages/provider/4/forget-password.vue")
  },
  {
    name: "provider-4-forget-password___zh-Hans",
    path: "/provider/4/forget-password",
    meta: forget_45password9_45whw7OpsuhekIsJvBYjDeJ03ooL4d_PUrvih8YQoYEMeta || {},
    component: () => import("/app/pages/provider/4/forget-password.vue")
  },
  {
    name: "provider-4-forget-password___zh-Hant",
    path: "/zh-Hant/provider/4/forget-password",
    meta: forget_45password9_45whw7OpsuhekIsJvBYjDeJ03ooL4d_PUrvih8YQoYEMeta || {},
    component: () => import("/app/pages/provider/4/forget-password.vue")
  },
  {
    name: "provider-4-onboarding___en-US",
    path: "/en-US/provider/4/onboarding",
    meta: indexmOmRThJkcwesi_eGK24Vtl_45p_xDFK9HfO_45RS2aRLg8YMeta || {},
    component: () => import("/app/pages/provider/4/onboarding/index.vue")
  },
  {
    name: "provider-4-onboarding___zh-Hans",
    path: "/provider/4/onboarding",
    meta: indexmOmRThJkcwesi_eGK24Vtl_45p_xDFK9HfO_45RS2aRLg8YMeta || {},
    component: () => import("/app/pages/provider/4/onboarding/index.vue")
  },
  {
    name: "provider-4-onboarding___zh-Hant",
    path: "/zh-Hant/provider/4/onboarding",
    meta: indexmOmRThJkcwesi_eGK24Vtl_45p_xDFK9HfO_45RS2aRLg8YMeta || {},
    component: () => import("/app/pages/provider/4/onboarding/index.vue")
  },
  {
    name: "provider-onboarding-success___en-US",
    path: "/en-US/provider/onboarding-success",
    component: () => import("/app/pages/provider/onboarding-success.vue")
  },
  {
    name: "provider-onboarding-success___zh-Hans",
    path: "/provider/onboarding-success",
    component: () => import("/app/pages/provider/onboarding-success.vue")
  },
  {
    name: "provider-onboarding-success___zh-Hant",
    path: "/zh-Hant/provider/onboarding-success",
    component: () => import("/app/pages/provider/onboarding-success.vue")
  },
  {
    name: "provider-3-mgmt-appt-calendar___en-US",
    path: "/en-US/provider/3/mgmt/appt/calendar",
    meta: calendarX6afqn_45EIKOySE0LqlOGs1o1vllMK2HpkhB6OcYF3JIMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/appt/calendar.vue")
  },
  {
    name: "provider-3-mgmt-appt-calendar___zh-Hans",
    path: "/provider/3/mgmt/appt/calendar",
    meta: calendarX6afqn_45EIKOySE0LqlOGs1o1vllMK2HpkhB6OcYF3JIMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/appt/calendar.vue")
  },
  {
    name: "provider-3-mgmt-appt-calendar___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/appt/calendar",
    meta: calendarX6afqn_45EIKOySE0LqlOGs1o1vllMK2HpkhB6OcYF3JIMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/appt/calendar.vue")
  },
  {
    name: "provider-3-mgmt-app-i693___en-US",
    path: "/en-US/provider/3/mgmt/app/i693",
    meta: indexwttrCs10Cud39AT7BdyStAJMBejL7Lq3x2zJJEPUmbkMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/app/i693/index.vue")
  },
  {
    name: "provider-3-mgmt-app-i693___zh-Hans",
    path: "/provider/3/mgmt/app/i693",
    meta: indexwttrCs10Cud39AT7BdyStAJMBejL7Lq3x2zJJEPUmbkMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/app/i693/index.vue")
  },
  {
    name: "provider-3-mgmt-app-i693___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/app/i693",
    meta: indexwttrCs10Cud39AT7BdyStAJMBejL7Lq3x2zJJEPUmbkMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/app/i693/index.vue")
  },
  {
    name: "provider-4-dashboard-telephony___en-US",
    path: "/en-US/provider/4/dashboard/telephony",
    meta: { ...(telephonyH0AaOQdf2lrmdYA462ISNCvnXyLmnLI9ghyvR401LB8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/telephony.vue")
  },
  {
    name: "provider-4-dashboard-telephony___zh-Hans",
    path: "/provider/4/dashboard/telephony",
    meta: { ...(telephonyH0AaOQdf2lrmdYA462ISNCvnXyLmnLI9ghyvR401LB8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/telephony.vue")
  },
  {
    name: "provider-4-dashboard-telephony___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/telephony",
    meta: { ...(telephonyH0AaOQdf2lrmdYA462ISNCvnXyLmnLI9ghyvR401LB8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/telephony.vue")
  },
  {
    name: "provider-3-mgmt-change-password___en-US",
    path: "/en-US/provider/3/mgmt/change-password",
    meta: change_45passwordsR_4Yteo7kxJMmnUFTUH9OUt2lX9TlLAWozzWqGVvB0Meta || {},
    component: () => import("/app/pages/provider/3/mgmt/change-password.vue")
  },
  {
    name: "provider-3-mgmt-change-password___zh-Hans",
    path: "/provider/3/mgmt/change-password",
    meta: change_45passwordsR_4Yteo7kxJMmnUFTUH9OUt2lX9TlLAWozzWqGVvB0Meta || {},
    component: () => import("/app/pages/provider/3/mgmt/change-password.vue")
  },
  {
    name: "provider-3-mgmt-change-password___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/change-password",
    meta: change_45passwordsR_4Yteo7kxJMmnUFTUH9OUt2lX9TlLAWozzWqGVvB0Meta || {},
    component: () => import("/app/pages/provider/3/mgmt/change-password.vue")
  },
  {
    name: "provider-4-dashboard-blog___en-US",
    path: "/en-US/provider/4/dashboard/blog",
    meta: { ...(indexs0uDmdC7RprN9gGW8_dD_d_4571NiQnUR9tMKfXm39IdIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/blog/index.vue")
  },
  {
    name: "provider-4-dashboard-blog___zh-Hans",
    path: "/provider/4/dashboard/blog",
    meta: { ...(indexs0uDmdC7RprN9gGW8_dD_d_4571NiQnUR9tMKfXm39IdIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/blog/index.vue")
  },
  {
    name: "provider-4-dashboard-blog___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/blog",
    meta: { ...(indexs0uDmdC7RprN9gGW8_dD_d_4571NiQnUR9tMKfXm39IdIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/blog/index.vue")
  },
  {
    name: "provider-4-dashboard-team___en-US",
    path: "/en-US/provider/4/dashboard/team",
    meta: indexxWu0_457igiwKtsfTYH27jTwr_451ULMrhvOB08UaZ0f_K0Meta || {},
    component: () => import("/app/pages/provider/4/dashboard/team/index.vue")
  },
  {
    name: "provider-4-dashboard-team___zh-Hans",
    path: "/provider/4/dashboard/team",
    meta: indexxWu0_457igiwKtsfTYH27jTwr_451ULMrhvOB08UaZ0f_K0Meta || {},
    component: () => import("/app/pages/provider/4/dashboard/team/index.vue")
  },
  {
    name: "provider-4-dashboard-team___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/team",
    meta: indexxWu0_457igiwKtsfTYH27jTwr_451ULMrhvOB08UaZ0f_K0Meta || {},
    component: () => import("/app/pages/provider/4/dashboard/team/index.vue")
  },
  {
    name: "provider-care-coordination___en-US",
    path: "/en-US/provider/care-coordination",
    meta: { ...(indexU9RhFYRKDyTVWscV2qgNgSPB7ENg2ro1j4CWs_45JkW0MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/index.vue")
  },
  {
    name: "provider-care-coordination___zh-Hans",
    path: "/provider/care-coordination",
    meta: { ...(indexU9RhFYRKDyTVWscV2qgNgSPB7ENg2ro1j4CWs_45JkW0MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/index.vue")
  },
  {
    name: "provider-care-coordination___zh-Hant",
    path: "/zh-Hant/provider/care-coordination",
    meta: { ...(indexU9RhFYRKDyTVWscV2qgNgSPB7ENg2ro1j4CWs_45JkW0MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/index.vue")
  },
  {
    name: "doctor-specialty-slug___en-US",
    path: "/en-US/doctor/:specialty()/:slug?",
    component: () => import("/app/pages/doctor/[specialty]/[[slug]]/index.vue")
  },
  {
    name: "doctor-specialty-slug___zh-Hans",
    path: "/doctor/:specialty()/:slug?",
    component: () => import("/app/pages/doctor/[specialty]/[[slug]]/index.vue")
  },
  {
    name: "doctor-specialty-slug___zh-Hant",
    path: "/zh-Hant/doctor/:specialty()/:slug?",
    component: () => import("/app/pages/doctor/[specialty]/[[slug]]/index.vue")
  },
  {
    name: "provider-4-dashboard-accountlevel___en-US",
    path: "/en-US/provider/4/dashboard/accountlevel",
    meta: { ...(accountlevel3RkmvtFauhsDMbHGXiWIcZTaFPmU5OeTBKHcY7xdlkQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/accountlevel.vue")
  },
  {
    name: "provider-4-dashboard-accountlevel___zh-Hans",
    path: "/provider/4/dashboard/accountlevel",
    meta: { ...(accountlevel3RkmvtFauhsDMbHGXiWIcZTaFPmU5OeTBKHcY7xdlkQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/accountlevel.vue")
  },
  {
    name: "provider-4-dashboard-accountlevel___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/accountlevel",
    meta: { ...(accountlevel3RkmvtFauhsDMbHGXiWIcZTaFPmU5OeTBKHcY7xdlkQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/accountlevel.vue")
  },
  {
    name: "provider-care-coordination-create___en-US",
    path: "/en-US/provider/care-coordination/create",
    meta: { ...(createEkfNSuyjjmIx8gUYB4d0lFZL_kZaqre35CdglKtvQKYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/create.vue")
  },
  {
    name: "provider-care-coordination-create___zh-Hans",
    path: "/provider/care-coordination/create",
    meta: { ...(createEkfNSuyjjmIx8gUYB4d0lFZL_kZaqre35CdglKtvQKYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/create.vue")
  },
  {
    name: "provider-care-coordination-create___zh-Hant",
    path: "/zh-Hant/provider/care-coordination/create",
    meta: { ...(createEkfNSuyjjmIx8gUYB4d0lFZL_kZaqre35CdglKtvQKYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/create.vue")
  },
  {
    name: "provider-4-dashboard-clinics___en-US",
    path: "/en-US/provider/4/dashboard/clinics",
    meta: { ...(indexeZsFY5HMMWlb2d_45Qslz1yjGDreziFZS0Vpx862Jw2hgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/clinics/index.vue")
  },
  {
    name: "provider-4-dashboard-clinics___zh-Hans",
    path: "/provider/4/dashboard/clinics",
    meta: { ...(indexeZsFY5HMMWlb2d_45Qslz1yjGDreziFZS0Vpx862Jw2hgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/clinics/index.vue")
  },
  {
    name: "provider-4-dashboard-clinics___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/clinics",
    meta: { ...(indexeZsFY5HMMWlb2d_45Qslz1yjGDreziFZS0Vpx862Jw2hgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/clinics/index.vue")
  },
  {
    name: "provider-care-coordination-scanner___en-US",
    path: "/en-US/provider/care-coordination/scanner",
    component: () => import("/app/pages/provider/care-coordination/scanner.vue")
  },
  {
    name: "provider-care-coordination-scanner___zh-Hans",
    path: "/provider/care-coordination/scanner",
    component: () => import("/app/pages/provider/care-coordination/scanner.vue")
  },
  {
    name: "provider-care-coordination-scanner___zh-Hant",
    path: "/zh-Hant/provider/care-coordination/scanner",
    component: () => import("/app/pages/provider/care-coordination/scanner.vue")
  },
  {
    name: "provider-4-dashboard-schedules___en-US",
    path: "/en-US/provider/4/dashboard/schedules",
    meta: index3638Y_45B95zkaIRFyIC7S6yhK19PEJa9jryVfCJActS0Meta || {},
    component: () => import("/app/pages/provider/4/dashboard/schedules/index.vue")
  },
  {
    name: "provider-4-dashboard-schedules___zh-Hans",
    path: "/provider/4/dashboard/schedules",
    meta: index3638Y_45B95zkaIRFyIC7S6yhK19PEJa9jryVfCJActS0Meta || {},
    component: () => import("/app/pages/provider/4/dashboard/schedules/index.vue")
  },
  {
    name: "provider-4-dashboard-schedules___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/schedules",
    meta: index3638Y_45B95zkaIRFyIC7S6yhK19PEJa9jryVfCJActS0Meta || {},
    component: () => import("/app/pages/provider/4/dashboard/schedules/index.vue")
  },
  {
    name: "provider-4-dashboard-scheduling___en-US",
    path: "/en-US/provider/4/dashboard/scheduling",
    meta: indexkq7nWEjFUaDyMvftYOJv4nJajcYkCAEc3OCHCUcCkFAMeta || {},
    component: () => import("/app/pages/provider/4/dashboard/scheduling/index.vue")
  },
  {
    name: "provider-4-dashboard-scheduling___zh-Hans",
    path: "/provider/4/dashboard/scheduling",
    meta: indexkq7nWEjFUaDyMvftYOJv4nJajcYkCAEc3OCHCUcCkFAMeta || {},
    component: () => import("/app/pages/provider/4/dashboard/scheduling/index.vue")
  },
  {
    name: "provider-4-dashboard-scheduling___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/scheduling",
    meta: indexkq7nWEjFUaDyMvftYOJv4nJajcYkCAEc3OCHCUcCkFAMeta || {},
    component: () => import("/app/pages/provider/4/dashboard/scheduling/index.vue")
  },
  {
    name: "provider-4-dashboard-blog-blog-editing___en-US",
    path: "/en-US/provider/4/dashboard/blog/blog-editing",
    meta: { ...(blog_45editingB_72DznYvxbzZD2gwdV1iGPrhXiw60ebaA9R_45IK5UZQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/blog/blog-editing.vue")
  },
  {
    name: "provider-4-dashboard-blog-blog-editing___zh-Hans",
    path: "/provider/4/dashboard/blog/blog-editing",
    meta: { ...(blog_45editingB_72DznYvxbzZD2gwdV1iGPrhXiw60ebaA9R_45IK5UZQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/blog/blog-editing.vue")
  },
  {
    name: "provider-4-dashboard-blog-blog-editing___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/blog/blog-editing",
    meta: { ...(blog_45editingB_72DznYvxbzZD2gwdV1iGPrhXiw60ebaA9R_45IK5UZQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/blog/blog-editing.vue")
  },
  {
    name: "provider-care-coordination-edit-uuid___en-US",
    path: "/en-US/provider/care-coordination/edit/:uuid()",
    meta: { ...(_91uuid_93r448MYyBG1r37fXAbihea3ZDkvPqoFa6JpSBCw24_RcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/edit/[uuid].vue")
  },
  {
    name: "provider-care-coordination-edit-uuid___zh-Hans",
    path: "/provider/care-coordination/edit/:uuid()",
    meta: { ...(_91uuid_93r448MYyBG1r37fXAbihea3ZDkvPqoFa6JpSBCw24_RcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/edit/[uuid].vue")
  },
  {
    name: "provider-care-coordination-edit-uuid___zh-Hant",
    path: "/zh-Hant/provider/care-coordination/edit/:uuid()",
    meta: { ...(_91uuid_93r448MYyBG1r37fXAbihea3ZDkvPqoFa6JpSBCw24_RcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/care-coordination/edit/[uuid].vue")
  },
  {
    name: "doctor-specialty-slug-appointment___en-US",
    path: "/en-US/doctor/:specialty()/:slug?/appointment",
    component: () => import("/app/pages/doctor/[specialty]/[[slug]]/appointment.vue")
  },
  {
    name: "doctor-specialty-slug-appointment___zh-Hans",
    path: "/doctor/:specialty()/:slug?/appointment",
    component: () => import("/app/pages/doctor/[specialty]/[[slug]]/appointment.vue")
  },
  {
    name: "doctor-specialty-slug-appointment___zh-Hant",
    path: "/zh-Hant/doctor/:specialty()/:slug?/appointment",
    component: () => import("/app/pages/doctor/[specialty]/[[slug]]/appointment.vue")
  },
  {
    name: "provider-4-dashboard-appointments___en-US",
    path: "/en-US/provider/4/dashboard/appointments",
    meta: { ...(indexxFAwUUtygNwLrLOBjkVN79ZIslCgVfdW9ReLALfwhLkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/appointments/index.vue")
  },
  {
    name: "provider-4-dashboard-appointments___zh-Hans",
    path: "/provider/4/dashboard/appointments",
    meta: { ...(indexxFAwUUtygNwLrLOBjkVN79ZIslCgVfdW9ReLALfwhLkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/appointments/index.vue")
  },
  {
    name: "provider-4-dashboard-appointments___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/appointments",
    meta: { ...(indexxFAwUUtygNwLrLOBjkVN79ZIslCgVfdW9ReLALfwhLkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/appointments/index.vue")
  },
  {
    name: "provider-4-dashboard-account-upgrade-done___en-US",
    path: "/en-US/provider/4/dashboard/account-upgrade-done",
    meta: { ...(account_45upgrade_45doneJZ2OuLTE__F0Dj1E1fnGtUZq1Omjo8rNNuUOI_45vIVesMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/account-upgrade-done.vue")
  },
  {
    name: "provider-4-dashboard-account-upgrade-done___zh-Hans",
    path: "/provider/4/dashboard/account-upgrade-done",
    meta: { ...(account_45upgrade_45doneJZ2OuLTE__F0Dj1E1fnGtUZq1Omjo8rNNuUOI_45vIVesMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/account-upgrade-done.vue")
  },
  {
    name: "provider-4-dashboard-account-upgrade-done___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/account-upgrade-done",
    meta: { ...(account_45upgrade_45doneJZ2OuLTE__F0Dj1E1fnGtUZq1Omjo8rNNuUOI_45vIVesMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/account-upgrade-done.vue")
  },
  {
    name: "provider-care-coordination-success-uuid___en-US",
    path: "/en-US/provider/care-coordination/success/:uuid()",
    meta: _91uuid_93k7Ci4EEJYqNL5_knaVpMiinngEixoJlJewYJfmAjFEUMeta || {},
    component: () => import("/app/pages/provider/care-coordination/success/[uuid].vue")
  },
  {
    name: "provider-care-coordination-success-uuid___zh-Hans",
    path: "/provider/care-coordination/success/:uuid()",
    meta: _91uuid_93k7Ci4EEJYqNL5_knaVpMiinngEixoJlJewYJfmAjFEUMeta || {},
    component: () => import("/app/pages/provider/care-coordination/success/[uuid].vue")
  },
  {
    name: "provider-care-coordination-success-uuid___zh-Hant",
    path: "/zh-Hant/provider/care-coordination/success/:uuid()",
    meta: _91uuid_93k7Ci4EEJYqNL5_knaVpMiinngEixoJlJewYJfmAjFEUMeta || {},
    component: () => import("/app/pages/provider/care-coordination/success/[uuid].vue")
  },
  {
    name: "provider-3-mgmt-insurance-eligibility___en-US",
    path: "/en-US/provider/3/mgmt/insurance-eligibility",
    meta: indexZdg_45dBZDn62ucR5ofpE44nCAFtGZV1On9UNKm8YXExIMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/insurance-eligibility/index.vue")
  },
  {
    name: "provider-3-mgmt-insurance-eligibility___zh-Hans",
    path: "/provider/3/mgmt/insurance-eligibility",
    meta: indexZdg_45dBZDn62ucR5ofpE44nCAFtGZV1On9UNKm8YXExIMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/insurance-eligibility/index.vue")
  },
  {
    name: "provider-3-mgmt-insurance-eligibility___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/insurance-eligibility",
    meta: indexZdg_45dBZDn62ucR5ofpE44nCAFtGZV1On9UNKm8YXExIMeta || {},
    component: () => import("/app/pages/provider/3/mgmt/insurance-eligibility/index.vue")
  },
  {
    name: "provider-3-mgmt-app-communications-voip___en-US",
    path: "/en-US/provider/3/mgmt/app/communications/voip",
    component: () => import("/app/pages/provider/3/mgmt/app/communications/voip/index.vue")
  },
  {
    name: "provider-3-mgmt-app-communications-voip___zh-Hans",
    path: "/provider/3/mgmt/app/communications/voip",
    component: () => import("/app/pages/provider/3/mgmt/app/communications/voip/index.vue")
  },
  {
    name: "provider-3-mgmt-app-communications-voip___zh-Hant",
    path: "/zh-Hant/provider/3/mgmt/app/communications/voip",
    component: () => import("/app/pages/provider/3/mgmt/app/communications/voip/index.vue")
  },
  {
    name: "provider-4-dashboard-clinics-update-facility-locations___en-US",
    path: "/en-US/provider/4/dashboard/clinics/update-facility-locations",
    meta: { ...(update_45facility_45locationsnKARdlHTQ4Rtv44w2rZHJlbp1dK340EsS9f6pCxNI1oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/clinics/update-facility-locations.vue")
  },
  {
    name: "provider-4-dashboard-clinics-update-facility-locations___zh-Hans",
    path: "/provider/4/dashboard/clinics/update-facility-locations",
    meta: { ...(update_45facility_45locationsnKARdlHTQ4Rtv44w2rZHJlbp1dK340EsS9f6pCxNI1oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/clinics/update-facility-locations.vue")
  },
  {
    name: "provider-4-dashboard-clinics-update-facility-locations___zh-Hant",
    path: "/zh-Hant/provider/4/dashboard/clinics/update-facility-locations",
    meta: { ...(update_45facility_45locationsnKARdlHTQ4Rtv44w2rZHJlbp1dK340EsS9f6pCxNI1oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/provider/4/dashboard/clinics/update-facility-locations.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en-US/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/zh-Hant/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]